/**
 * Configuration options for opening a file dialog
 */
interface FileDialogOptions {
  /** MIME types or extensions (e.g., "image/*", ".pdf,.docx") */
  accept?: string;
  /** Allow selecting multiple files */
  multiple?: boolean;
}

/**
 * Opens a system file selection dialog and returns a Promise resolving to the selected File(s).
 * Returns undefined if the user cancels the dialog or no files are selected.
 */
export function openFileDialog(
  options: FileDialogOptions = {},
): Promise<File[] | undefined> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.style.display = 'none';
    input.accept = options.accept ?? '';
    input.multiple = options.multiple ?? false;

    const cleanup = () => {
      input.remove();
    };

    input.onchange = () => {
      if (input.files && input.files.length > 0) {
        const files = Array.from(input.files);
        resolve(files);
      } else {
        resolve(undefined);
      }
      cleanup();
    };

    input.addEventListener('cancel', () => {
      resolve(undefined);
      cleanup();
    });

    document.body.appendChild(input);
    input.click();
  });
}
